export const CONFIRM_CANDIDATE_LABEL = 'Confirm Candidate';

export const StatusEnum = {
  pending: 'CONFIRM CANDIDATE',
  completed: 'COMPLETED',
  scheduled: 'SCHEDULED',
  today: 'TODAY',
  open: 'OPEN',
  cancelled: 'CANCELLED',
  expired: 'EXPIRED',
  cancelledOrExpired: 'CANCELLED OR EXPIRED',
};

export const FilterStatusEnum = {
  UPCOMING: 'upcoming',
  COMPLETED: 'past',
  PENDING: 'pending',
  PENDING_COUNTER: 'pending-counter',
  COUNTER: 'counter',
  SCHEDULED: 'filled',
  TODAY: 'today',
  OPEN: 'open',
  CANCELLED_OR_EXPIRED: 'cancelled-or-expired',
} as const;

export type TFilterStatusEnum = (typeof FilterStatusEnum)[keyof typeof FilterStatusEnum];

/** Display labels for the Schedule filter dropdown and calendar legend. */
export const FilterStatusLabel = {
  [FilterStatusEnum.UPCOMING]: 'All Upcoming',
  [FilterStatusEnum.TODAY]: 'Today',
  [FilterStatusEnum.PENDING_COUNTER]: CONFIRM_CANDIDATE_LABEL,
  [FilterStatusEnum.SCHEDULED]: 'Scheduled',
  [FilterStatusEnum.OPEN]: 'Open',
  [FilterStatusEnum.COMPLETED]: 'Completed',
  [FilterStatusEnum.CANCELLED_OR_EXPIRED]: 'Cancelled & Expired',
} as const;

export const OfficeTypeEnum = {
  DSO: 'dso',
  PRIVATE_PRACTICE_MULTI: 'private_practice_multi',
  PRIVATE_PRACTICE_INDEPENDENT: 'private_practice_independent',
};

export const timePerPatientOptions = ['N/A', '30 min', '45 min', '1 hr', '1.5 hr', '2+ hr'];

export enum ReceiptTransactionDateEnum {
  ALL = 'All',
  CURRENT_MONTH = 'CURRENT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  YEAR_TO_DATE = 'YEAR_TO_DATE',
  LAST_YEAR = 'LAST_YEAR',
}
